<template>
    <div>
        <p class="text-subtitle1">
            Select clients to assign them to the user.
        </p>
        <client-search-input v-model="keyword" filled outlined dense />
        <unassigned-clients-table
                :user-id="user.id"
                :keyword="keyword"
                v-model:selected="selected"
                class="q-mt-md"
                ref="clients"
        />
        <div class="text-center q-mt-md">
            <async-btn
                    v-show="selected.length"
                    :task="task"
                    label="Assign"
                    color="primary"
                    @click="assign"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { User, Client, List } from '@/type';
import ClientSearchInput from '@/client/ClientSearchInput.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import UnassignedClientsTable from './UnassignedClientsTable.vue';
import { assignAll } from './user-client';

interface Data {
  keyword: string|null,
  selected: Client[],
  task: Promise<any>|null,
}

export default defineComponent({
  components: {
    ClientSearchInput,
    UnassignedClientsTable,
    AsyncBtn,
  },
  props: {
    user: {
      type: Object as () => User,
      required: true,
    },
  },
  data(): Data {
    return {
      keyword: null,
      selected: [],
      task: null,
    };
  },
  methods: {
    assign(): void {
      const clientIds = this.selected.map(c => c.id);
      this.task = assignAll(this.user.id, clientIds);
      this.task.then(() => {
        const name = `${this.user.firstName} ${this.user.lastName}`;
        const total = this.selected.length;
        notify(
          `Assigned ${total} client${(total === 1) ? '' : 's'} to ${name}`,
        );

        this.selected.forEach((c) => {
          (this.$refs.clients as List).removeItem(c);
        });
        this.selected = [];
      });
    },
  },
});
</script>
